import {cioTrack, getAnonymousId} from "@/lib/analytics/customerio";

/**
 * Customer.io event names — current integration stage (Confluence "Retention").
 * AC-613 covers the frontend / website-interaction (§11) subset + web-push.
 */
export const CioEvents = {
    SITE_VISITED_WITHOUT_REGISTRATION: "site_visited_without_registration",
    BONUS_PAGE_VIEWED: "bonus_page_viewed",
    BONUS_MODAL_CLOSED: "bonus_modal_closed",
    CONTACT_MODAL_CLOSED: "contact_modal_closed",
    VIP_BANNER_CLICKED: "vip_banner_clicked",
    LOYALTY_PROGRAM_BANNER_CLICKED: "loyalty_program_banner_clicked",
    WEB_PUSH_SUBSCRIBED: "web_push_subscribed",
} as const;

const currentPageUrl = (): string | undefined =>
    typeof window === "undefined" ? undefined : window.location.href;

/** Adds `player_id` when authenticated, otherwise the persisted `anonymous_id`. */
const withIdentity = (
    playerId: string | undefined,
    data: Record<string, unknown>,
): Record<string, unknown> => ({
    ...(playerId ? {player_id: playerId} : {anonymous_id: getAnonymousId()}),
    ...data,
});

/**
 * TODO(AC-613): the VIP and loyalty-program banners do not exist in the UI yet.
 * These helpers are ready to wire to the real banner click handlers once those
 * components ship. Do NOT attach them to unrelated surfaces (welcome-bonus CTA,
 * the bonuses VIP tab, etc.) — that would feed misleading signal into CRM.
 */
export const trackVipBannerClicked = (params: {
    bannerId: string;
    pageUrl?: string;
    playerId?: string;
}): void => {
    cioTrack(
        CioEvents.VIP_BANNER_CLICKED,
        withIdentity(params.playerId, {
            banner_id: params.bannerId,
            page_url: params.pageUrl ?? currentPageUrl(),
            clicked_at: new Date().toISOString(),
        }),
    );
};

export const trackLoyaltyProgramBannerClicked = (params: {
    bannerId: string;
    pageUrl?: string;
    playerId?: string;
}): void => {
    cioTrack(
        CioEvents.LOYALTY_PROGRAM_BANNER_CLICKED,
        withIdentity(params.playerId, {
            banner_id: params.bannerId,
            page_url: params.pageUrl ?? currentPageUrl(),
            clicked_at: new Date().toISOString(),
        }),
    );
};
